import { render, staticRenderFns } from "./curation-tool-audit-item-details.component.vue?vue&type=template&id=673f17d7"
import script from "./curation-tool-audit-item-details.component.vue?vue&type=script&lang=ts"
export * from "./curation-tool-audit-item-details.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports